import { getComponentName } from '../../helpers/componentHelpers';
import { createCssVarImageClass } from '../../baseClasses/createCssVarImageClass';

export const componentName = getComponentName('notp-image');

export const NotpImageClass = createCssVarImageClass({
  componentName,
  varName: 'url',
  fallbackVarName: 'fallbackUrl',
});
